(function () {
  'use strict';

  var config = window.dimarkWishlistConfig || {};
  var STORAGE_KEY = config.storageKey || 'dimark-wishlist';
  var strings = config.strings || {};
  var renderToken = 0;

  function parseJson(value, fallback) {
    try { return JSON.parse(value); } catch (e) { return fallback; }
  }

  function money(cents) {
    var format = (window.theme && (theme.moneyFormatWithCodeForProductsPreference || theme.moneyFormat)) || null;
    if (window.theme && theme.Shopify && typeof theme.Shopify.formatMoney === 'function' && format) {
      return theme.Shopify.formatMoney(cents, format);
    }
    return (Math.round(cents) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function shopRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.slice(-1) === '/' ? root : root + '/';
  }

  var HEART_SVG = '<svg class="icon icon--stroke-only icon--medium icon--type-heart" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78l-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8l8-8c2.67-2.72 2.54-6.3.42-8.42z"></path></svg>';

  function itemId(item) {
    return String(item.variantId || item.productId || '');
  }

  function readLocal() {
    if (!window.localStorage) return [];
    var raw = localStorage.getItem(STORAGE_KEY);
    var parsed = parseJson(raw, []);
    return Array.isArray(parsed) ? parsed : [];
  }

  function writeLocal(items) {
    if (!window.localStorage) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function merge(seed, local) {
    var map = {};
    [].concat(seed || [], local || []).forEach(function (item) {
      if (!item) return;
      var id = itemId(item);
      if (!id || map[id]) return;
      map[id] = item;
    });
    return Object.keys(map).map(function (key) { return map[key]; });
  }

  function customerGid() {
    if (!config.customerId) return null;
    return 'gid://shopify/Customer/' + config.customerId;
  }

  function persistMetafield(items) {
    var gid = customerGid();
    var domain = config.shopDomain;
    if (!gid || !domain) return Promise.resolve();
    var endpoint = 'https://' + domain + '/account/customer/api/' + (config.apiVersion || '2026-07') + '/graphql';
    var productGids = items.map(function (item) {
      return item.productId ? ('gid://shopify/Product/' + item.productId) : null;
    }).filter(Boolean);
    var unique = productGids.filter(function (id, index) { return productGids.indexOf(id) === index; });

    var query;
    var variables;
    if (unique.length) {
      query = 'mutation metafieldsSet($metafields: [MetafieldsSetInput!]!) { metafieldsSet(metafields: $metafields) { userErrors { message } } }';
      variables = {
        metafields: [{
          ownerId: gid,
          namespace: 'custom',
          key: 'buy_later_wish_list',
          type: 'list.product_reference',
          value: JSON.stringify(unique)
        }]
      };
    } else {
      query = 'mutation metafieldsDelete($metafields: [MetafieldIdentifierInput!]!) { metafieldsDelete(metafields: $metafields) { userErrors { message } } }';
      variables = {
        metafields: [{ ownerId: gid, namespace: 'custom', key: 'buy_later_wish_list' }]
      };
    }

    return fetch(endpoint, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    }).catch(function () {});
  }

  var items = merge(config.seed || [], readLocal());
  writeLocal(items);
  persistMetafield(items);

  function save(next) {
    items = next;
    writeLocal(items);
    persistMetafield(items);
    document.dispatchEvent(new CustomEvent('on:wishlist:change', { detail: { items: items, count: items.length } }));
  }

  function isSaved(variantId, productId) {
    return items.some(function (item) {
      return itemId(item) === String(variantId || productId || '');
    });
  }

  function fromButton(button) {
    return {
      productId: button.getAttribute('data-product-id'),
      variantId: button.getAttribute('data-variant-id'),
      handle: button.getAttribute('data-handle'),
      title: button.getAttribute('data-title'),
      url: button.getAttribute('data-url'),
      price: button.getAttribute('data-price'),
      priceCents: parseInt(button.getAttribute('data-price-cents'), 10) || 0,
      type: button.getAttribute('data-type'),
      image: button.getAttribute('data-image')
    };
  }

  function toggle(button) {
    var next = fromButton(button);
    var id = itemId(next);
    if (!id) return;
    if (isSaved(next.variantId, next.productId)) {
      if (button.closest('[data-wishlist-grid]')) {
        leaveAndRemove(id);
        return;
      }
      save(items.filter(function (item) { return itemId(item) !== id; }));
    } else {
      save(items.concat([next]));
    }
  }

  function syncButtons() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-toggle]'), function (button) {
      var pressed = isSaved(button.getAttribute('data-variant-id'), button.getAttribute('data-product-id'));
      button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      var label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = pressed ? (strings.remove || 'Remove') : (strings.add || 'Add to wishlist');
      button.setAttribute('aria-label', label ? label.textContent : (pressed ? (strings.remove || 'Remove') : (strings.add || 'Add to wishlist')));
    });
  }

  function syncCounts() {
    var count = items.length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-count]'), function (node) {
      node.textContent = count;
      node.hidden = count < 1;
    });
    syncButtons();
  }

  function resolveVariant(item, live) {
    if (!live || !live.variants || !live.variants.length) return null;
    var id = Number(item.variantId);
    for (var i = 0; i < live.variants.length; i++) {
      if (live.variants[i].id === id) return live.variants[i];
    }
    return live.variants[0];
  }

  function imageUrl(item, live, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (live && live.featured_image) return live.featured_image;
    return item.image || '';
  }

  function packCount(item, live, variant) {
    var opt = variant && variant.option1;
    var n = parseInt(opt, 10);
    if (n > 1) return n;
    var title = (item && item.title) || (live && live.title) || '';
    var stripped = String(title).replace(/\([^)]*\)/g, '');
    var matches = stripped.match(/(\d+)\s*[xX×]/g);
    if (!matches || !matches.length) return 0;
    return parseInt(matches[matches.length - 1], 10) || 0;
  }

  function unitPriceHtml(item, live, variant, livePrice) {
    var sep = strings.unitPriceSeparator || (window.theme && theme.strings && theme.strings.unitPriceSeparator) || ' / ';
    var unitCents = 0;
    var unitLabel = 'item';
    var measurement = variant && variant.unit_price_measurement;
    if (variant && variant.unit_price && measurement) {
      unitCents = variant.unit_price;
      unitLabel = ((measurement.reference_value && measurement.reference_value !== 1) ? String(measurement.reference_value) : '') + (measurement.reference_unit || 'item');
    } else if (livePrice) {
      var count = packCount(item, live, variant);
      if (count > 1) unitCents = Math.round(livePrice / count);
    }
    if (!unitCents) return '';
    return '<div class="unit-price"><span class="unit-price__price theme-money">' + money(unitCents) + '</span><span class="unit-price__separator">' + escapeHtml(sep) + '</span><span class="unit-price__unit">' + escapeHtml(unitLabel) + '</span></div>';
  }

  function fillMissingUnitPrices(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.product-price'), function (priceEl) {
      if (priceEl.querySelector('.unit-price')) return;
      var appattic = priceEl.querySelector('.appattic_price_app_coll');
      if (appattic && appattic.textContent && appattic.textContent.trim()) return;
      var variants = parseJson(appattic && appattic.getAttribute('data-variants'), []);
      var variant = variants[0];
      var pack = variant ? parseInt(variant.option1, 10) : 0;
      var pounds = appattic ? parseFloat(appattic.getAttribute('data-price')) : NaN;
      if (!(pack > 1) || !(pounds > 0)) return;
      var unitCents = Math.round((pounds / pack) * 100);
      var sep = strings.unitPriceSeparator || ' / ';
      priceEl.insertAdjacentHTML('afterbegin',
        '<div class="unit-price"><span class="unit-price__price theme-money">' + money(unitCents) + '</span><span class="unit-price__separator">' + escapeHtml(sep) + '</span><span class="unit-price__unit">item</span></div>'
      );
    });
  }

  function revealLazyImages(root) {
    Array.prototype.forEach.call(root.querySelectorAll('img.lazyload'), function (img) {
      var src = img.getAttribute('data-src') || '';
      if (!src || src.indexOf('data:') === 0) return;
      img.setAttribute('src', src.replace('{width}', '460'));
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
    });
    if (window.lazySizes && lazySizes.loader && typeof lazySizes.loader.checkElems === 'function') {
      lazySizes.loader.checkElems();
    }
  }

  function fallbackCard(item, live) {
    var variant = resolveVariant(item, live);
    var gone = live === null;
    var productAvailable = !!(live && live.available);
    var variantAvailable = !!(variant && variant.available);
    var singleVariant = !!(live && live.variants && live.variants.length === 1 && variantAvailable);
    var livePrice = variant && typeof variant.price === 'number'
      ? variant.price
      : (live && typeof live.price === 'number' ? live.price : item.priceCents);
    var compareAt = variant && variant.compare_at_price
      ? variant.compare_at_price
      : (live && live.compare_at_price);
    var onSale = !!(compareAt && livePrice && compareAt > livePrice);
    var url = escapeHtml(item.url || '#');
    var title = escapeHtml(item.title || '');
    var img = imageUrl(item, live, variant);
    var id = itemId(item);
    var variantId = variant ? variant.id : item.variantId;
    var addToOrder = strings.addToOrder || 'Add to order';
    var isCustomer = !!(window.themeAuthCta && window.themeAuthCta.hasCustomer);
    var labels = '';

    if (gone || (live && !productAvailable)) {
      labels += '<span class="product-label product-label--sold-out">' + escapeHtml(strings.soldOut || 'Sold out') + '</span>';
    } else if (onSale) {
      labels += '<span class="product-label product-label--on-sale">' + escapeHtml(strings.onSale || 'Sale') + '</span>';
    }

    var heart =
      '<button type="button" class="wishlist-button wishlist-button--topbar" data-wishlist-toggle' +
      ' data-product-id="' + escapeHtml(item.productId) + '"' +
      ' data-variant-id="' + escapeHtml(item.variantId) + '"' +
      ' data-handle="' + escapeHtml(item.handle) + '"' +
      ' data-title="' + title + '"' +
      ' data-url="' + url + '"' +
      ' data-price="' + escapeHtml(item.price) + '"' +
      ' data-price-cents="' + escapeHtml(item.priceCents) + '"' +
      ' data-type="' + escapeHtml(item.type) + '"' +
      (img ? ' data-image="' + escapeHtml(img) + '"' : '') +
      ' aria-pressed="true" aria-label="' + escapeHtml(strings.remove || 'Remove') + '">' +
      '<span class="wishlist-button__icon" aria-hidden="true">' + HEART_SVG + '</span>' +
      '</button>';

    var image = img
      ? '<a class="product-block__image product-block__image--shape-square" href="' + url + '">' +
          '<div class="image-one"><div class="rimage-outer-wrapper"><div class="rimage-wrapper" style="padding-top:100%">' +
            '<img class="rimage__image" src="' + escapeHtml(img) + '" alt="' + title + '">' +
          '</div></div></div></a>'
      : '<a class="product-block__image product-block__image--shape-square" href="' + url + '"></a>';

    var priceHtml = '<div class="product-price">';
    if (isCustomer) priceHtml += unitPriceHtml(item, live, variant, livePrice);
    if (livePrice) {
      priceHtml += '<span class="theme_money' + (onSale ? ' product-price__reduced' : '') + '">' + money(livePrice) + '</span>';
      if (onSale) priceHtml += '<span class="product-price__compare theme-money">' + money(compareAt) + '</span>';
    } else if (item.price) {
      priceHtml += '<span class="theme_money">' + escapeHtml(item.price) + '</span>';
    }
    priceHtml += '</div>';

    var action = '';
    var guestClass = isCustomer ? '' : ' product-block--guest-price';
    if (gone) {
      action = '<div class="product-block__oos">' + escapeHtml(strings.unavailable || 'No longer available') + '</div>';
    } else if (!isCustomer) {
      var auth = window.themeAuthCta || {};
      action =
        '<div class="notAuthorizedBox"><p class="notAuthorizedBoxText">' +
          '<a class="notAuthorizedBoxBtn" href="' + escapeHtml(auth.loginUrl || '/account/login') + '">' +
            '<span class="notAuthorizedBoxBtn__label">' + escapeHtml(auth.loginLabel || 'Login or Register') + '</span>' +
            '<span class="notAuthorizedBoxHint">' + escapeHtml(auth.loginHint || 'to see prices') + '</span>' +
          '</a></p></div>';
    } else if (!productAvailable) {
      action = '<div class="product-block__oos">' + escapeHtml(strings.backInStock || 'Back in stock soon') + '</div>';
    } else if (singleVariant) {
      action =
        '<div class="product-block__atc" data-pb-atc data-pb-atc-variant="' + escapeHtml(variantId) + '">' +
          '<div class="pb-atc__control">' +
            '<span class="pb-atc__label visually-hidden">' + escapeHtml(addToOrder) + '</span>' +
            '<div class="pb-atc__stepper">' +
              '<button type="button" class="pb-atc__step pb-atc__step--minus" data-pb-atc-minus aria-label="' + escapeHtml(strings.decreaseQty || 'Minus') + '">&minus;</button>' +
              '<span class="pb-atc__qty" data-pb-atc-qty aria-live="polite">0</span>' +
              '<button type="button" class="pb-atc__step pb-atc__step--plus" data-pb-atc-plus aria-label="' + escapeHtml(strings.increaseQty || 'Plus') + '">+</button>' +
            '</div></div></div>';
    } else if (productAvailable) {
      action =
        '<a class="product-block__atc product-block__atc--link" href="' + url + '">' +
          '<span class="pb-atc__label">' + escapeHtml(addToOrder) + '</span></a>';
    }

    return (
      '<div class="product-block grid-flex__item one-quarter small-down--one-half' + guestClass + '" data-wishlist-id="' + escapeHtml(id) + '" data-variant-id="' + escapeHtml(variantId || '') + '">' +
        '<div class="product-block__image-container">' +
          '<div class="global-border-radius relative">' + image + labels + heart + '</div>' +
        '</div>' +
        '<div class="product-block__title"><a href="' + url + '" class="product-block__title-link">' + title + '</a></div>' +
        priceHtml +
        action +
      '</div>'
    );
  }

  function chunk(list, size) {
    var out = [];
    for (var i = 0; i < list.length; i += size) out.push(list.slice(i, i + size));
    return out;
  }

  function fetchLiquidCards(handles) {
    var unique = [];
    handles.forEach(function (handle) {
      if (handle && unique.indexOf(handle) === -1) unique.push(handle);
    });
    if (!unique.length) return Promise.resolve('');
    return Promise.all(chunk(unique, 20).map(function (batch) {
      var url = shopRoot() + 'search?view=wishcards&q=' + encodeURIComponent(batch.join('~'));
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) { return parts.join(''); });
  }

  function hydrateInsertedCards(grid) {
    Array.prototype.forEach.call(grid.querySelectorAll('.product-block'), function (card) {
      var btn = card.querySelector('[data-wishlist-toggle]');
      var handle = (btn && btn.getAttribute('data-handle')) || card.getAttribute('data-wishlist-handle');
      var variantId = btn && btn.getAttribute('data-variant-id');
      var match = null;
      for (var i = 0; i < items.length; i++) {
        if (variantId && itemId(items[i]) === String(variantId)) {
          match = items[i];
          break;
        }
      }
      if (!match && handle) {
        for (var j = 0; j < items.length; j++) {
          if (items[j].handle === handle) {
            match = items[j];
            break;
          }
        }
      }
      if (match) {
        card.setAttribute('data-wishlist-id', itemId(match));
        card.setAttribute('data-variant-id', match.variantId || variantId || '');
      } else if (variantId && !card.getAttribute('data-wishlist-id')) {
        card.setAttribute('data-wishlist-id', variantId);
        card.setAttribute('data-variant-id', variantId);
      }
    });
    fillMissingUnitPrices(grid);
    revealLazyImages(grid);
    document.dispatchEvent(new CustomEvent('pb:cart-changed'));
    try {
      if (window.appattic_price_app && typeof window.appattic_price_app.init === 'function') {
        window.appattic_price_app.init();
      }
    } catch (e) {}
    syncButtons();
  }

  function renderedHandleSet(grid) {
    var set = {};
    Array.prototype.forEach.call(grid.querySelectorAll('[data-wishlist-toggle], [data-wishlist-handle]'), function (node) {
      var handle = node.getAttribute('data-handle') || node.getAttribute('data-wishlist-handle');
      if (handle) set[handle] = true;
    });
    return set;
  }

  function leaveAndRemove(id) {
    var card = document.querySelector('[data-wishlist-id="' + id + '"]');
    save(items.filter(function (item) { return itemId(item) !== String(id); }));
    if (!card) return renderGrid();
    card.classList.add('is-leaving');
    setTimeout(renderGrid, 280);
  }

  function updateAddAll(grid) {
    var addAll = document.querySelector('[data-wishlist-add-all]');
    if (!addAll) return;
    var steppers = grid.querySelectorAll('[data-pb-atc]');
    var isCustomer = !!(window.themeAuthCta && window.themeAuthCta.hasCustomer);
    if (isCustomer && steppers.length > 1) {
      addAll.hidden = false;
      addAll.textContent = strings.addAll || 'Add all to the basket';
    } else {
      addAll.hidden = true;
    }
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var addAll = document.querySelector('[data-wishlist-add-all]');
    var token = ++renderToken;

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (addAll) addAll.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;

    var handles = items.map(function (item) { return item.handle; }).filter(Boolean);
    fetchLiquidCards(handles).then(function (html) {
      if (token !== renderToken) return;
      var looksLikeCards = html && html.indexOf('<!--wishcards-->') !== -1;
      grid.innerHTML = looksLikeCards ? html : '';
      if (looksLikeCards) hydrateInsertedCards(grid);

      var found = renderedHandleSet(grid);
      var missing = items.filter(function (item) { return !item.handle || !found[item.handle]; });
      if (!missing.length) {
        updateAddAll(grid);
        return;
      }

      Promise.all(missing.map(function (item) {
        if (!item.handle) return Promise.resolve({ item: item, live: null });
        return fetch('/products/' + item.handle + '.js', { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) return { item: item, live: null };
            return res.json().then(function (data) { return { item: item, live: data }; });
          })
          .catch(function () { return { item: item, live: null }; });
      })).then(function (rows) {
        if (token !== renderToken) return;
        grid.insertAdjacentHTML('beforeend', rows.map(function (row) {
          return fallbackCard(row.item, row.live);
        }).join(''));
        hydrateInsertedCards(grid);
        updateAddAll(grid);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var toggleBtn = event.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      event.preventDefault();
      toggle(toggleBtn);
      return;
    }
    var removeBtn = event.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      var card = removeBtn.closest('[data-wishlist-id]');
      if (card) leaveAndRemove(card.getAttribute('data-wishlist-id'));
      return;
    }
    var addAllBtn = event.target.closest('[data-wishlist-add-all]');
    if (addAllBtn) {
      event.preventDefault();
      Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-grid] [data-pb-atc-plus]'), function (button) {
        button.click();
      });
    }
  });

  document.addEventListener('on:wishlist:change', syncCounts);
  syncCounts();

  window.dimarkWishlist = {
    toggle: toggle,
    renderGrid: renderGrid,
    items: function () { return items.slice(); }
  };

  if (document.querySelector('[data-wishlist-grid]')) renderGrid();
})();
